import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useLogout } from '@/context/auth-context'
import { signOut } from '@/lib/auth-client'
import { trackEvent } from '@/lib/posthog'
import { useEffect, useRef, useState } from 'react'
import { Link } from '@tanstack/react-router'
import { beginLogout, clearAuthData, redirectToLoginAfterLogout } from '@/lib/auth'

export const Route = createFileRoute('/(auth)/logout')({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = useNavigate()
  const logoutJotaiStore = useLogout()
  const loggedOut = useRef(false)
  const [isClearing, setIsClearing] = useState(true)

  useEffect(() => {
    // Prevent multiple executions
    if (loggedOut.current) return

    const performLogout = async () => {
      console.log('>>> Starting logout process')
      await beginLogout()

      try {
        // Track logout
        trackEvent('auth.logout', {
          timestamp: new Date().toISOString()
        })
      } catch (error) {
        console.error('Failed to track logout:', error)
      }

      try {
        // Step 1: Sign out from Better-Auth FIRST (needs token from localStorage)
        await signOut()
      } catch (error) {
        console.error('Failed to sign out from Better-Auth:', error)
      } finally {
        // Step 2: Clear all cache layers (localStorage, localforage, React Query)
        await clearAuthData()

        // Step 3: Remount Jotai store (resets all atoms)
        logoutJotaiStore()
      }

      loggedOut.current = true
      setIsClearing(false)
      console.log('>>> Logout complete')

      redirectToLoginAfterLogout(navigate)
    }

    performLogout()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // Empty dependency array to run only once

  if (isClearing) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="text-lg">Signing out...</div>
        </div>
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="text-lg mb-4">You have been signed out.</div>
        <Link to="/login" className="text-primary hover:underline">
          Click here to sign in again
        </Link>
      </div>
    </div>
  )
}
